import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ReservationsStoreEffects } from './reservations.effects';
import { dashboardReservationsStoreFeatureKey, reducer } from './reservations.reducers';

export function provideReservationsStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(dashboardReservationsStoreFeatureKey, reducer),
    provideEffects([ReservationsStoreEffects]),
  ]);
}
